import { PropsWithChildren } from "react";
import styled from "styled-components";

import { Box } from "@vinomofo/components";

interface SelectorOptionProps {
  isSelected?: boolean;
  activeColor?: string;
  onClick: () => void;
}

const StyledBox = styled(Box)`
  outline: 0;
  border: 5px solid ${({ theme }) => theme.colors.darkMofo};
  cursor: pointer;
`;

export const SelectorOption = ({
  children,
  onClick,
  isSelected = false,
  activeColor = "primary",
}: PropsWithChildren<SelectorOptionProps>): JSX.Element => {
  return (
    <StyledBox
      as="button"
      onClick={onClick}
      backgroundColor={isSelected ? activeColor : "black"}
      padding="20px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="220px"
      flex="1"
    >
      {children}
    </StyledBox>
  );
};
